import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from 'src/services/payment/payment.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-payment-successful',
  templateUrl: './payment-successful.component.html',
  styleUrls: ['./payment-successful.component.scss']
})
export class PaymentSuccessfulComponent implements OnInit {
  loading: boolean;
  isPaid: boolean;
  reference: string;
  
  constructor(private paymentService: PaymentService, private router: Router) { }

  ngOnInit(): void {
    this.reference = localStorage.getItem('reference');
    if (localStorage.getItem('pay_id')) {
      this.loading = true;
      this.paymentService.verified(localStorage.getItem('pay_id'), this.reference).subscribe({
        next: response => {
          this.loading = false;
          this.isPaid = true;
          localStorage.removeItem('pay_id');
          localStorage.removeItem('reference');
        },
        error: error => {
          this.loading = false;
          this.isPaid = false;
          let message = error.error.detail || error.error.non_error_fields[0];

          console.log(message);
        }
      })
    }
  }
}
